import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'

import { Wrapper, IconBox } from './styles'

/**
 * PaymentIcons
 *
 * @returns {node} PaymentIcons
 */
const PaymentIcons = ({ icons }) => (
  <Wrapper>
    {icons.map(icon => (
      <IconBox key={`icon__${icon}`} id={icon}>
        <Icon id={`pay_${icon}`} />
      </IconBox>
    ))}
  </Wrapper>
)

PaymentIcons.propTypes = {
  icons: PropTypes.array.isRequired,
}

export default PaymentIcons
